import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
      // 登录
      {path: '/Admin/login',name: 'login',component: () => import('./views/Admin/login.vue')},
    //   {path: '/',name: 'index',component: () => import('./views/index.vue')},

      // 后台界面
      {path:"/Admin/index",name:"admin_index",component:()=>import("./views/Admin/index"),children:[

        {path:"/Admin/index",name:"admin_default",component:()=>import("./views/Admin/default")}, // 打开默认页面

        // 用户 Users
        {path:"/Admin/users/index",name:"users_index",component:()=>import("./views/Admin/users/index")},
        {path:"/Admin/users/info",name:"users_info",component:()=>import("./views/Admin/users/info")},
        {path:"/Admin/users/form",name:"users_form",component:()=>import("./views/Admin/users/form")},
        {path:"/Admin/users/inviter/:id",name:"admin_get_inviter_by_id",component:()=>import("./views/Admin/users/inviter")},
         //促销管理
         {path:"/Admin/promotion/index",name:"promotion_index",component:()=>import("./views/Admin/promotion/index")},
         {path:"/Admin/promotion/form/:id?",name:"promotion_form",component:()=>import("./views/Admin/promotion/form")},
 

        // 财务资金
        {path:"/Admin/draw_cash/index",name:"draw_cash_index",component:()=>import("./views/Admin/draw_cash/index")},
        {path:"/Admin/money_log/index",name:"money_log_index",component:()=>import("./views/Admin/money_log/index")},
        {path:"/Admin/order_pay/index",name:"order_pay_index",component:()=>import("./views/Admin/order_pay/index")},
        {path:"/Admin/withdraw/index",name:"withdraw_index",component:()=>import("./views/Admin/withdraw/index")},
        {path:"/Admin/inviterdetails/index",name:"inviterdetails",component:()=>import("./views/Admin/inviterdetails/index")},
        {path:"/Admin/commison/index",name:"commison",component:()=>import("./views/Admin/commison/index")},
        // 配置页面 Config
        {path:"/Admin/config/web_config",name:"web_config",component:()=>import("./views/Admin/config/web_config")},
        {path:"/Admin/config/alisms_config",name:"alisms_config",component:()=>import("./views/Admin/config/alisms_config")},
        {path:"/Admin/config/balance_warn",name:"balance_warn",component:()=>import("./views/Admin/config/balance_warn")},
        {path:"/Admin/config/storage_config",name:"storage_config",component:()=>import("./views/Admin/config/storage_config")},
        {path:"/Admin/config/royalty",name:"royalty",component:()=>import("./views/Admin/config/royalty")},
        {path:"/Admin/config/storage_form/:id/:name",name:"storage_form",component:()=>import("./views/Admin/config/storage_form")},
        {path:"/Admin/config/colorset",name:"colorset",component:()=>import("./views/Admin/config/colorset")},

        // 商品日志
        {path:"/Admin/goods_log/index",name:"admin_goods_log_index",component:()=>import("./views/Admin/goods_log/index")},

        // 单页管理
        {path:"/Admin/pages/index",name:"pages_index",component:()=>import("./views/Admin/pages/index")},
        {path:"/Admin/pages/form",name:"pages_form",component:()=>import("./views/Admin/pages/form")},

       
        // 文章管理
        {path:"/Admin/article/index",name:"article_index",component:()=>import("./views/Admin/article/index")},
        {path:"/Admin/article/form",name:"article_form",component:()=>import("./views/Admin/article/form")},

        // 售后处理
        {path:"/Admin/after_sale/check_pieces",name:"admin_check_pieces_index",component:()=>import("./views/Admin/check_pieces/index")},
        {path:"/Admin/after_sale/receive_order",name:"admin_receive_order_index",component:()=>import("./views/Admin/receive_order/index")},

        // 订单管理
        {path:"/Admin/order/index",name:"admin_order_index",component:()=>import("./views/Admin/order/index")},
        {path:"/Admin/order/info/:id",name:"admin_order_info",component:()=>import("./views/Admin/order/info")},
        {path:"/Admin/order_receipt/index",name:"admin_order_receipt",component:()=>import("./views/Admin/order_receipt/index")}, // 包裹订单


        // 广告位
        {path:"/Admin/adv_position/index",name:"adv_position_index",component:()=>import("./views/Admin/adv_position/index")},

        // 广告
        {path:"/Admin/adv/index",name:"adv_index",component:()=>import("./views/Admin/adv/index")},
        {path:"/Admin/adv/form",name:"adv_form",component:()=>import("./views/Admin/adv/form")},

        // 统计数据
        {path:"/Admin/statistics/user",name:"statistics_user",component:()=>import("./views/Admin/statistics/user")},
        {path:"/Admin/statistics/order",name:"statistics_order",component:()=>import("./views/Admin/statistics/order")},
        {path:"/Admin/statistics/receipt",name:"statistics_receipt",component:()=>import("./views/Admin/statistics/receipt")},
        {path:"/Admin/statistics/goods",name:"statistics_goods",component:()=>import("./views/Admin/statistics/goods")},
        {path:"/Admin/statistics/pay",name:"statistics_pay",component:()=>import("./views/Admin/statistics/pay")},



      ]},

      // 首页
      {path: '/',name: 'home_index',component: () => import('./views/Home/index'),meta:{title:'代发兔,非空包专业商品代发平台,淘宝天猫、京东、拼多多补单优选'}},
    //   {path: '/code=:code',name: 'home_index2',component: () => import('./views/Home/index'),meta:{title:'代发兔,非空包专业商品代发平台,淘宝天猫、京东、拼多多补单优选'}},
      {path: '/spread',name: 'home_spread',component: () => import('./views/Home/adv/spread'),meta:{title:'代发兔-商家入驻'}},  
      {path: '/subjoin',name: 'home_subjoin',component: () => import('./views/Home/adv/subjoin'),meta:{title:'代发兔-分站加盟'}},   //分站加盟

      {path: '/login',name: 'home_login',component: () => import('./views/Home/login'),meta:{title:'用户登录'}},
      {path: '/reg',name: 'home_reg',component: () => import('./views/Home/register'),meta:{title:'用户注册'}},
      {path: '/forget_password',name: 'home_forget_password',component: () => import('./views/Home/forget_password'),meta:{title:'-找回密码'}},

      {path: '/goods',name: 'home_goods',component: () => import('./views/Home/goods/index'),meta:{title:'-商品列表'}},
      {path: '/goods_purchase',name: 'home_goods_purchase',component: () => import('./views/Home/goods/goods_purchase'),meta:{title:'私有仓库'}},
      {path: '/goods_history',name: 'home_goods_history',component: () => import('./views/Home/goods/goods_history'),meta:{title:'-历史购买'}},
      {path: '/goods/:id',name: 'home_goods_info',component: () => import('./views/Home/goods/info')},

      // {path: '/news',name: 'home_news',component: () => import('./views/Home/news/index')},
      // {path: '/news/:id',name: 'home_news_info',component: () => import('./views/Home/news/info')},

      // 用户中心
      {path:"/user",name:"home_user_index",component:()=>import("./views/Home/user/index"),children:[
        {path: '/user',name: 'user_index',component: () => import('./views/Home/user/default'),meta:{title:'-用户中心'}}, // 默认页面
        {path: '/user/order',name: 'user_order',component: () => import('./views/Home/user/order'),meta:{title:'-订单列表'}}, // 订单
        {path: '/user/receipt',name: 'user_receipt',component: () => import('./views/Home/user/receipt'),meta:{title:'-订单包裹'}}, // 订单包裹
        {path: '/user/order_purchase',name: 'user_order_purchase',component: () => import('./views/Home/user/order_purchase'),meta:{title:'-预购订单'}}, // 预购订单
        {path: '/user/order_purchase_log',name: 'user_order_purchase_log',component: () => import('./views/Home/user/order_purchase_log'),meta:{title:'-预购消耗记录'}}, // 预购消耗记录
        {path: '/user/inviter',name: 'user_inviter',component: () => import('./views/Home/user/inviter'),meta:{title:'-邀请好友'}}, // 邀请好友
        {path: '/user/recharge/:actid?',name: 'user_recharge',component: () => import('./views/Home/user/recharge'),meta:{title:'-充值资金'}}, // 获取资金变动recharge
        {path: '/user/money_log',name: 'user_money_log',component: () => import('./views/Home/user/money_log'),meta:{title:'-资金明细'}}, // 充值资金
        {path: '/user/inviterdetails',name: 'user_inviterdetails',component: () => import('./views/Home/user/inviterdetails'),meta:{title:'-邀请奖励'}}, // 邀请人提成奖励
        {path: '/user/vip',name: 'user_vip',component: () => import('./views/Home/user/vip'),meta:{title:'-升级会员'}}, // 升级会员
        {path: '/user/benefits',name: 'user_benefits',component: () => import('./views/Home/user/benefits'),meta:{title:'收费标准'}}, // 收费标准
        {path: '/user/identityVerification',name: 'user_identityVerification',component: () => import('./views/Home/user/identityVerification'),meta:{title:'实名认证'}}, // 实名认证
        {path: '/user/edit_password',name: 'user_edit_password',component: () => import('./views/Home/user/edit_password'),meta:{title:'-修改密码'}}, // 修改密码
        {path: '/user/edit_member',name: 'user_edit_member',component: () => import('./views/Home/user/edit_member'),meta:{title:'-修改用户信息'}}, // 修改用户信息
        {path: '/user/check_pieces',name: 'user_check_pieces',component: () => import('./views/Home/user/check_pieces'),meta:{title:'-售后查件'}}, // 售后查件
        {path: '/user/receive_order',name: 'user_receive_order',component: () => import('./views/Home/user/receive_order'),meta:{title:'-底单查询'}}, // 底单查询
        {path: '/user/pages/:ename',name: 'user_pages',component: () => import('./views/Home/user/pages'),meta:{title:'-'}}, // 单页信息
        {path: '/user/storageAddress',name: 'user_pages_storageAddress',component: () => import('./views/Home/user/storageAddress'),meta:{title:'-'}}, // 单页信息
        {path: '/user/forbid_list',name: 'user_forbid_list',component: () => import('./views/Home/user/buy/forbid_list'),meta:{title:'-快递停发区域'}}, // 快递停发区域

        // 发货
        {path: '/user/send_order',name: 'user_send_order',component: () => import('./views/Home/user/buy/index'),meta:{title:'-发货'}}, // 发货 step 1
        {path: '/user/pdd_check_order',name: 'user_pdd_check_order',component: () => import('./views/Home/user/buy/pdd_check_order'),meta:{title:'-拼多多发货'}}, // 拼多多发货
        {path: '/user/tb_check_order',name: 'user_tb_check_order',component: () => import('./views/Home/user/buy/tb_check_order'),meta:{title:'-淘宝发货'}}, // 淘宝发货
        {path: '/user/dy_check_order',name: 'user_dy_check_order',component: () => import('./views/Home/user/buy/dy_check_order'),meta:{title:'-抖音发货'}}, // 抖音发货
        {path: '/user/check_order',name: 'user_check_order',component: () => import('./views/Home/user/buy/check_order'),meta:{title:'-发货 step2'}}, // 发货 step2
        {path: '/user/chose_goods',name: 'user_chose_goods',component: () => import('./views/Home/user/buy/chose_goods'),meta:{title:'-发货 step 3'}}, // 发货 step 3
        {path: '/user/step_1/:id',name: 'user_step_1',component: () => import('./views/Home/user/buy/step_1'),meta:{title:'-确认付款'}}, // 发货 step 4

        // 店铺授权
        {path: '/user/shop',name: 'user_shop',component: () => import('./views/Home/user/shopList'),meta:{title:'代发兔-店铺授权'}},

        // 入仓代发
        {path: '/user/substitute',name: 'user_substitute',component: () => import('./views/Home/user/substitute'),meta:{title:'-入仓代发'}}, 

        // 店铺授权
        {path: '/user/shop',name: 'user_shop',component: () => import('./views/Home/user/shopList'),meta:{title:'代发兔-店铺授权'}},
      ]},



      

  ]
})
